import { render } from "./doctorRating.vue?vue&type=template&id=362ff3b3&scoped=true"
import script from "./doctorRating.vue?vue&type=script&lang=js"
export * from "./doctorRating.vue?vue&type=script&lang=js"

import "./doctorRating.vue?vue&type=style&index=0&id=362ff3b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362ff3b3"]])

export default __exports__